import { render } from "./data-table.vue?vue&type=template&id=319c5c1d&scoped=true"
import script from "./data-table.vue?vue&type=script&lang=js"
export * from "./data-table.vue?vue&type=script&lang=js"

import "./data-table.vue?vue&type=style&index=0&id=319c5c1d&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319c5c1d"]])

export default __exports__